__turbopack_context__.v({
  "agencyMemberWrapper": "MembersOfAgency-module__xa7hRG__agencyMemberWrapper",
  "image": "MembersOfAgency-module__xa7hRG__image",
  "imageRatio": "MembersOfAgency-module__xa7hRG__imageRatio",
  "sectionAgency": "MembersOfAgency-module__xa7hRG__sectionAgency",
  "subsection": "MembersOfAgency-module__xa7hRG__subsection",
  "subtitle": "MembersOfAgency-module__xa7hRG__subtitle",
});
